<!-- @Author: ruiwang -->
<!-- @Date: 2024-02-24 11:17:06 -->
<!-- @Last Modified by: xiaodongyu -->
<!-- @Last Modified time: 2024-02-28 18:29:39 -->

<template>
    <register-layout :step="2">
        <div class="rs2">
            <h2 class="bold">
                会員登録
            </h2>
            <section>
                <p class="b3 mt24">
                    仮登録完了後ご入力頂いたメールアドレスへ本会員登録のご案内を配信します。
                </p>
                <p class="b3">
                    ※ 自動配信メールが届かない場合は、「インスタキャッシュ」のドメイン（instachsh.jp）を許可する設定になっているかご確認ください。
                </p>
                <h5 class="email mt24">
                    <img
                        src="./img/email.png"
                        class="email-logo"
                    >
                    xukejp@yahoo.co.jp
                </h5>
            </section>
            <section
                v-if="!isServer && form"
                class="mt60 fm-1"
            >
                <a-form
                    layout="vertical"
                    :form="form"
                    @submit.prevent="handleSubmit"
                >
                    <section class="controler-box">
                        <template
                            v-for="option in options1"
                        >
                            <a-form-item
                                :key="option.field"
                                :label="option.label"
                            >
                                <a-radio-group
                                    v-if="option.type === 'radio'"
                                    v-decorator="genDecorator(option)"
                                    class="custom-btn-radio-group"
                                >
                                    <a-radio-button
                                        v-for="item in option.options"
                                        :key="item.value"
                                        :value="item.value"
                                    >
                                        {{ item.label }}
                                    </a-radio-button>
                                </a-radio-group>

                                <a-date-picker
                                    v-if="option.type === 'date'"
                                    v-decorator="genDecorator(option)"
                                    :placeholder="option.placeholder"
                                    style="width: 100%;"
                                />
                                <a-input
                                    v-if="!option.type || option.type === 'input'"
                                    v-decorator="genDecorator(option)"
                                    :placeholder="option.placeholder"
                                />
                            </a-form-item>
                        </template>
                    </section>
                    <div class="b2 mt60 mb28">
                        本人名義の銀行口座情報を入力してください。
                    </div>
                    <section class="controler-box">
                        <template
                            v-for="option in options2"
                        >
                            <a-form-item
                                :key="option.field"
                                :label="option.label"
                            >
                                <a-radio-group
                                    v-if="option.type === 'radio'"
                                    v-decorator="genDecorator(option)"
                                    class="custom-btn-radio-group"
                                >
                                    <a-radio-button
                                        v-for="item in option.options"
                                        :key="item.value"
                                        :value="item.value"
                                    >
                                        {{ item.label }}
                                    </a-radio-button>
                                </a-radio-group>

                                <a-date-picker
                                    v-if="option.type === 'date'"
                                    v-decorator="genDecorator(option)"
                                    :placeholder="option.placeholder"
                                    style="width: 100%;"
                                />
                                <a-input
                                    v-if="!option.type || option.type === 'input'"
                                    v-decorator="genDecorator(option)"
                                    :placeholder="option.placeholder"
                                />
                                <div v-if="option.field === 'accountHolder'">
                                    <div class="b4">
                                        小文字は入力できません。
                                    </div>
                                    <div class="b4">
                                        長音記号は「-」（半角マイナスハイフン）にて入力ください。
                                    </div>
                                </div>
                            </a-form-item>
                        </template>
                    </section>

                    <div class="b2 mt60 mb28">
                        リスク評価アンケートにご協力ください
                    </div>
                    <section>
                        <template
                            v-for="option in options3"
                        >
                            <a-form-item
                                :key="option.field"
                                :label="option.label"
                            >
                                <a-radio-group
                                    v-if="option.type === 'radio'"
                                    v-decorator="genDecorator(option)"
                                    class="custom-btn-radio-group"
                                >
                                    <a-radio-button
                                        v-for="item in option.options"
                                        :key="item.value"
                                        :value="item.value"
                                    >
                                        {{ item.label }}
                                    </a-radio-button>
                                </a-radio-group>
                                <a-checkbox-group
                                    v-if="option.type === 'checkbox'"
                                    v-decorator="genDecorator(option)"
                                    :options="option.options"
                                    class="custom-btn-checkbox-group"
                                />
                                <a-date-picker
                                    v-if="option.type === 'date'"
                                    v-decorator="genDecorator(option)"
                                    :placeholder="option.placeholder"
                                    style="width: 100%;"
                                />
                                <a-input
                                    v-if="!option.type || option.type === 'input'"
                                    v-decorator="genDecorator(option)"
                                    :placeholder="option.placeholder"
                                    :suffix="option.suffix"
                                />
                                <div
                                    v-if="option.field === 'financialAssets'"
                                    class="b4 c-04 mt4"
                                >
                                    当社ファンドの購入上限はお客様の金融資産の５０％までです。
                                </div>
                            </a-form-item>
                        </template>
                    </section>
                    <a-form-item>
                        <button
                            :disabled="!canSubmit"
                            type="primary"
                        >
                            次へ
                        </button>
                    </a-form-item>
                </a-form>
            </section>
        </div>
        <template #tip>
            <div class="my-tip">
                <h1 class="bold c-09">
                    ウェルカム
                </h1>
                <h5 class="c-09">
                    xukejp@yahoo.co.jp
                </h5>
            </div>
        </template>
    </register-layout>
</template>

<script>
import {isServer} from 'ssr-common/constant/config';

import RegisterLayout from '../component/register-layout';
import {fieldsMap, options1, options2, options3, genOptions} from './fields';

export default {
    name: 'RegisterStep2',

    components: {
        RegisterLayout
    },

    data() {
        return {
            fieldsMap,
            options1: genOptions(options1, fieldsMap),
            options2: genOptions(options2, fieldsMap),
            options3: genOptions(options3, fieldsMap),
            form: null,
            isServer: isServer(),
            formData: null,
            canSubmit: false
        };
    },

    computed: {
        optionMap() {
            const {options1, options2, options3} = this;

            return [...options1, ...options2, ...options3].reduce((acc, cur) => {
                const {field, ...option} = cur;

                return {
                    ...acc,
                    [field]: option
                };
            }, {});
        }
    },

    mounted() {
        const {onValuesChange} = this;
        this.form = this.$form.createForm(this, {
            name: 'step2',
            onValuesChange
        });
        this.$store.commit('finance/updateFinance', {
            currentStepRouteName: 'RegisterStep2-1'
        });
    },

    methods: {
        genOptions,

        genDecorator(option) {
            const {field, rules: originRules = [], required} = option;
            const requiredMsg = ' ';
            const requiredRule = {required, message: requiredMsg};

            const rules = [].concat(requiredRule, originRules);

            return [field, {rules}];
        },

        onValuesChange(props, value, values) {
            this.formData = values;
            if (values.lossOfPrincipal === 1) {
                this.canSubmit = false;

                return;
            }

            this.canSubmit = Object.keys(values).every(field => this.checkRequired({field, values}));
        },

        checkRequired({field, values}) {
            const option = this.optionMap[field] || {};

            const value = values[field];
            let res = true;
            if (option.required) {
                res = !!value || value === 0;
            }

            return res;
        },

        handleSubmit() {
            const {canSubmit} = this;
            if (!canSubmit) return;

            this.$router.push({name: 'RegisterStep2-2'});
            /**
            this.form.validateFields((err, values) => {
                if (!err) {
                    // eslint-disable-next-line no-console
                    console.log('Received values of form: ', values);
                    this.$router.push({name: 'RegisterStep2-2'});
                }
            });
            */
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~instacash/common/style/finance/index.scss";

.c-09 {
    color: $c-09;
}

.c-04 {
    color: $c-04;
}

.red-02 {
    color: $red-02;
}

.rs2 {
    .mt4 {
        margin-top: 0.04rem;
    }

    .mt24 {
        margin-top: 0.24rem;
    }

    .mt28 {
        margin-top: 0.28rem;
    }

    .mb28 {
        margin-bottom: 0.28rem;
    }

    .mt60 {
        margin-top: 0.6rem;
    }

    .pt24 {
        padding-top: 0.24rem;
    }

    .pt28 {
        padding-top: 0.28rem;
    }

    .email {
        width: fit-content;
        display: flex;
        align-items: center;
        padding: 0.1rem 0.2rem;
        background-color: $grey-01;
        border-radius: 0.12rem;

        &-logo {
            margin-right: 0.18rem;
            width: 0.24rem;
        }
    }

    .fm {
        border: 1px solid blue;
    }

    &-bg {
        position: sticky;
        top: 1.2rem;
        border: 1px solid red;
        width: 5.56rem;
        height: 7rem;
    }

    .controler-box {
        display: flex;
        flex-wrap: wrap;

        .ant-form-item {
            width: calc(50% - 0.15rem);
            margin-bottom: 0.24rem;

            &:nth-child(odd) {
                margin-right: 0.3rem;
            }
        }
    }

    .ant-input,
    .ant-input-affix-wrapper {
        max-width: 3rem;
    }
}

</style>
